import ComponentDescription from "components/customs/ComponentDescription";
import ComponentHeader from "components/cms/ComponentHeader";
import { ImageDefinitions } from "./ImageDefinitions";

export class Image extends ImageDefinitions {
  render() {
    const { className, designing } = this.props;

    return (
      <div
        data-schema-id={this.props.id}
        className={[
          "fa-draggable fa-Image",
          designing && "designing",
          className
        ]
          .filter((e) => !!e)
          .join(" ")}
      >
        {designing && (
          <ComponentHeader
            componentEntry={this.props.entry}
            componentSchemaId={this.props.id as string}
          />
        )}
        <ComponentDescription
          node={this.props.schemaNode}
          entry={this.props.entry}
        />
      </div>
    );
  }
}
